    // Script to truncate breadcrumb items that exceed 40 characthers and adds title tag with full text for accessibility
    (function() {  
        var breadcrumbItems = document.querySelectorAll(".breadcrumb-item");
    
        breadcrumbItems.forEach(function(item) {
            var link = item.querySelector("a"); // Check if the breadcrumb item has a link
            var fullText = link ? link.textContent : item.textContent; // Get the text from the link or the breadcrumb item
    
            if (fullText.length > 40) {
                var truncatedText = fullText.substring(0, 40) + "...";
                
                if (link) {
                    link.textContent = truncatedText;
                    link.setAttribute("title", fullText); // Add full text as tooltip to the link
                } else {
                    item.textContent = truncatedText;
                    item.setAttribute("title", fullText); // Add full text as tooltip to the plain text item
                }
            }
        });
    })();
    